import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/dictionary/editorialBoardRole/findAll')
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/dictionary/editorialBoardRole', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/dictionary/editorialBoardRole', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/dictionary/editorialBoardRole/' + id)
  }
}
